import Auth from '@/services/auth.js'

export default {
    computed: {
        denseMode () {
            var lsDenseMode = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_DENSE_MODE');
            if(lsDenseMode === '1'){
                return true
            }
            return false
        }
    }
}
